import { useMemo } from 'react'
import { useQuery } from '@tanstack/react-query'
import { useAppView } from '@/hooks/useAppView'
import { usePlatformGuard } from '@/hooks/usePlatformGuard'
import { fetchProfilesBatch } from '@/services/profileService'
export type { ProfileBasic } from '@/services/profileService'

/**
 * Batch-fetch profile data (avatar, isVerified) for a list of DIDs.
 * Returns a Map<DID, ProfileBasic> once loaded.
 * Respects the active app view so profile data reflects the user's chosen indexer.
 */
export function useProfileBatch(dids: string[]) {
    const { publicAgent, appView } = useAppView()
    const isCompatible = usePlatformGuard('atproto')
    const sortedDids = useMemo(() => [...dids].sort(), [dids])

    return useQuery({
        queryKey: ['profileBatch', sortedDids, appView],
        queryFn: () => fetchProfilesBatch(sortedDids, publicAgent),
        enabled: sortedDids.length > 0 && isCompatible,
        staleTime: 15 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
    })
}
